import React from 'react';
import { Link } from 'react-router-dom';

import routes from 'app/routes';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>No prospects to show</h2>

      <div className="mb-4">There are no prospects to show this time</div>

      <Link
        to={routes.affiliates.prospects.new}
        className="btn btn-outline-primary"
      >
        Submit New Prospect
      </Link>
    </div>
  );
}
